import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f60a764c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f60a764c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60a764c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60a764c')) {
      api.createRecord('f60a764c', component.options)
    } else {
      api.reload('f60a764c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f60a764c&scoped=true&", function () {
      api.rerender('f60a764c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PMEZMel14lp5/JS/comp/DocBox.vue"
export default component.exports